// src/components/ui/SectionTitle.js
import React from 'react';

const SectionTitle = ({ title }) => {
  return (
    <div className="text-center mb-16">
      <h2 className="text-3xl lg:text-4xl font-serif font-bold text-gray-900 relative inline-block">
        {title}
        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-[#8e293e] mt-2"></span>
      </h2>
    </div>
  );
};

export default SectionTitle;